import Image from 'next/image';
import React, { FC } from 'react';
import { processImageUrl } from '../../../../utils/urls';
import { ContentTitle, HeroPlaceHolderImageContainer, ContentTitleContainer } from './HeroImageComponent.styles';

type Props = {
	imageUrl: string;
	title?: string;
	priority?: boolean;
};

export const HeroPlaceHolderImage: FC<Props> = ({ imageUrl, priority = false }) => (
	<HeroPlaceHolderImageContainer>{imageUrl && <Image priority={priority} src={processImageUrl(imageUrl)} alt="mobile image" fill sizes="100vw" style={{ objectFit: 'cover' }} />}</HeroPlaceHolderImageContainer>
);

export const HeroIcon: FC<Props> = ({ imageUrl, title }) => {
	return (
		<>
			{imageUrl ? (
				<HeroPlaceHolderImageContainer>
					<Image priority src={processImageUrl(imageUrl)} alt="shows logo" fill sizes="100vw" style={{ objectFit: 'cover' }} />
				</HeroPlaceHolderImageContainer>
			) : (
				<ContentTitleContainer>
					<ContentTitle>{title}</ContentTitle>
				</ContentTitleContainer>
			)}
		</>
	);
};
